class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();

        // rc-added
        const event = new CustomEvent('cart:updated', { detail: parsedState });
        document.dispatchEvent(event);
        // end of rc-add
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });


    // console.log("Cart changed")
    // console.log(document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems'))
    // var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
    //   .then(response => response.json())
    //   .then(data => console.log(data));
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};

// rc-added
// function handleAddCartRecommendations(productID) {
//   fetch(
//     window.Shopify.routes.root +
//     `recommendations/products?product_id=${productID}&limit=2&section_id=custom-cart-recommendations&intent=related`
//   )
//     .then((response) => response.text())
//     .then((text) => {
//       document.querySelector('.drawer__footer').insertAdjacentHTML('afterbegin', text)
//       document.querySelectorAll(".cart-recommendations_a2c-button").forEach(button => {
//         button.addEventListener('click', (e) => {
//           let variantID = e.currentTarget.dataset.variantId;
//           handleAddRecommendationToCart(variantID)
//         })
//       })
//     })
//     .catch((error) => {
//       console.error('Error:', error);
//     });
// }

function handleAddRecommendationToCart(variantID) {
  let formData = {
    'items': [{
      'id': variantID,
      'quantity': 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => response.json())
    .then(() => document.querySelector('cart-drawer-items').updateQuantity(1))
    .catch((error) => {
      console.error('Error:', error);
    });
}

// document.addEventListener('cart:updated', event => handleAddCartRecommendations(event.detail.items[0].product_id))
// document.addEventListener('cart:rendered', event => handleAddCartRecommendations(event.detail.product_id))

document.getElementById('CartDrawer-Checkout').addEventListener('click', () => {
  document.getElementById('CartDrawer-Checkout').querySelector(".loading-overlay__spinner").classList.remove("hidden");
})

const recommendedProductHTML = (product) => {
  return `<li class="cart-recommendations__product">
  <a href="${product.url}" class="cart-recommendations__link-container full-unstyled-link">
    <img
      class="cart-recommendations__product-img"
      src="${product.image}"
      alt="${product.title}"
      width="75"
      height="75"
      loading="lazy"
    >
    <div>
      <p class="cart-recommendations__product-title heading-font">${product.title}</p>
      <p class="cart-recommendations__product-price">${product.price}</p>
    </div>
  </a>
  <button
    class="cart-recommendations_a2c-button button button--primary"
    data-variant-id="${product.id}"
  >
    Add
    <div class="loading-overlay hidden">
      <div class="loading-overlay__spinner">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    </div>
  </button>
</li>`}

const ssbCartRecommendationsArray = JSON.parse(atob((document.querySelector("#ssb-cart-recommendations").dataset.meta))).cartRecommendations;

const getCartItemIDs = async () => {
  const response = await fetch(window.Shopify.routes.root + 'cart.js')
  const data = await response.json()
  return data.items.map(item => item.variant_id)
}

function duplicatesRemovedArray(arr1, arr2) {
  return arr2.filter((rec) => !arr1.includes(Number(rec.id)));
}

async function handleAddRecommendationsSection() {
  const cartIDs = await getCartItemIDs();
  const uniqueRecommendations = duplicatesRemovedArray(cartIDs, ssbCartRecommendationsArray);

  if (cartIDs.length > 0 && uniqueRecommendations.length > 2) {
    fetch(window.location.pathname + "?section_id=ssb-cart-recommendations-html")
      .then(res => res.text())
      .then(data => {
        document.querySelectorAll("#shopify-section-ssb-cart-recommendations-html").forEach(section => section.remove())
        // Add the container
        document.querySelector('.drawer__footer').insertAdjacentHTML('afterbegin', data)
        //Add the recommendations
        for (let i = 0; i < 2; i++) {
          document.querySelector(".cart-recommendations>.cart-recommendations__list").insertAdjacentHTML('beforeend', recommendedProductHTML(uniqueRecommendations[i]))
        }

        document.querySelectorAll(".cart-recommendations_a2c-button").forEach(button => {
          button.addEventListener('click', (e) => {
            let variantID = e.currentTarget.dataset.variantId;
            e.currentTarget.querySelector(".button.cart-recommendations_a2c-button.button.button--primary>.loading-overlay").classList.remove('hidden');
            e.currentTarget.style.color = "transparent";
            handleAddRecommendationToCart(variantID)
          })
        })
      })
  }
}

window.onload = () => {
  handleAddRecommendationsSection()
  document.addEventListener('cart:updated', () => handleAddRecommendationsSection())
  document.addEventListener('cart:rendered', () => handleAddRecommendationsSection())
}





